import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/risques/risqueCardView.css';

const EquipmentGridData = React.memo(({ index, style, data }) => {

    const { equipements, columns, filteredEquipementsCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredEquipementsCount);

    const handleEquipmentClick = useCallback((equipmentId) => navigate(`equipement_details/${equipmentId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const equipementIndex = startIndex + idx;
                const equipement = equipements[equipementIndex];

                const imageUrl = entityGridPhotoUrl(equipement, 'equipment', { size: 'small' });

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={equipement ? equipement.id : `skeleton-${equipementIndex}`}>
                        <Card className='risques_gridview_card' style={{ position: 'relative', overflow: 'hidden' }}>
                            <CardActionArea onClick={equipement ? () => handleEquipmentClick(equipement?.id) : undefined}>
                                {equipement ? (
                                    <>
                                        {/* Blurred Background Image */}
                                        <CardMedia
                                            component="img"
                                            image={imageUrl}
                                            alt=""
                                            style={{
                                                position: 'absolute',
                                                width: '100%',
                                                height: '192px',
                                                top: 0,
                                                left: 0,
                                                zIndex: 0,
                                                objectFit: 'cover',
                                                filter: 'blur(10px)',
                                            }}
                                            loading="lazy"
                                            decoding="async"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = machineDefaultImage;
                                            }}
                                        />

                                        {/* Main Image Over Content */}
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            style={{
                                                position: 'relative',
                                                objectFit: imageUrl !== machineDefaultImage ? 'contain' : 'cover',
                                                zIndex: 1
                                            }}
                                            image={imageUrl}
                                            alt={equipement?.name}
                                            loading="lazy"
                                            decoding="async"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = machineDefaultImage;
                                            }}
                                        />
                                        <CardContent className='risques_gridview_card_CardContent' style={{ position: 'relative', zIndex: 2 }}>
                                            <Typography className='risques_gridview_risque_name' component="div">{equipement?.name}</Typography>
                                            <Typography className='risques_gridview_risque_adress' component="div">{equipement?.description || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton loading state */}
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default EquipmentGridData;